var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.deliverableTemplateDetail,
          expression: "deliverableTemplateDetail"
        }
      ],
      staticClass: "edit-deliverable-modal",
      class:
        !_vm.userAbilities.editMediaCall ||
        _vm.deliverableTemplateDetail.permissions.viewOnly
          ? "read-only"
          : ""
    },
    [
      _c("div", { staticClass: "departments__wrapper" }, [
        _c("div", { staticClass: "template-editor-heading" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("h1", [
            _vm._v("Edit Deliverable Template:\n        "),
            _c(
              "span",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.editTitle,
                    expression: "!editTitle"
                  }
                ],
                staticClass:
                  "exclude-outside-click edit-d-title deliverable-template-title",
                on: { click: _vm.activateTitleField }
              },
              [
                _vm._v(
                  _vm._s(
                    _vm.deliverableTemplateDetail.title || "Click to set..."
                  )
                )
              ]
            ),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "click-outside",
                  rawName: "v-click-outside",
                  value: _vm.outside,
                  expression: "outside"
                },
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.editTitle,
                  expression: "editTitle"
                },
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.deliverableTemplateDetail.title,
                  expression: "deliverableTemplateDetail.title"
                }
              ],
              ref: "deliverableTitle",
              staticClass:
                "form-control mb-3 deliverable-template-title-field exclude-outside-click h1",
              attrs: {
                type: "text",
                placeholder: _vm.getDeliverableTitlePlaceholder
              },
              domProps: { value: _vm.deliverableTemplateDetail.title },
              on: {
                change: _vm.updateDeliverableTemplateTitle,
                blur: function($event) {
                  _vm.editTitle = false
                },
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(
                    _vm.deliverableTemplateDetail,
                    "title",
                    $event.target.value
                  )
                }
              }
            })
          ])
        ]),
        _vm._v(" "),
        false
          ? _c("div", { staticClass: "deliverable-departments" }, [_vm._m(1)])
          : _vm._e(),
        _vm._v(" "),
        false
          ? _c("div", { staticClass: "deliverable-departments" }, [_vm._m(2)])
          : _vm._e(),
        _vm._v(" "),
        false
          ? _c("div", { staticClass: "deliverable-projects" }, [_vm._m(3)])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-md-5" }, [
          _vm._m(4),
          _vm._v(" "),
          _c("label", { staticClass: "form-group w-100" }, [
            _c(
              "h1",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.editDefaultTitle,
                    expression: "!editDefaultTitle"
                  }
                ],
                staticClass:
                  "exclude-outside-click edit-d-title deliverable-title",
                on: { click: _vm.activateDefaultTitleField }
              },
              [
                _vm._v(
                  _vm._s(
                    _vm.deliverableTemplateDetail.default_title ||
                      "Click to set..."
                  )
                )
              ]
            ),
            _vm._v(" "),
            _c("textarea", {
              directives: [
                {
                  name: "click-outside",
                  rawName: "v-click-outside",
                  value: _vm.outside,
                  expression: "outside"
                },
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.editDefaultTitle,
                  expression: "editDefaultTitle"
                },
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.deliverableTemplateDetail.default_title,
                  expression: "deliverableTemplateDetail.default_title"
                }
              ],
              ref: "deliverableDefaultTitle",
              staticClass:
                "form-control mb-3 title-field exclude-outside-click h1",
              attrs: {
                type: "text",
                placeholder: _vm.getDeliverableTitlePlaceholder
              },
              domProps: { value: _vm.deliverableTemplateDetail.default_title },
              on: {
                change: _vm.updateDeliverableTemplateDefaultTitle,
                blur: function($event) {
                  _vm.editDefaultTitle = false
                },
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(
                    _vm.deliverableTemplateDetail,
                    "default_title",
                    $event.target.value
                  )
                }
              }
            })
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-7" }, [
          _c("div", { staticClass: "form-group" }, [
            _vm._m(5),
            _vm._v(" "),
            _vm.relatedTags.length
              ? _c(
                  "div",
                  { staticClass: "trending-tags" },
                  [
                    _c("label", [_vm._v("Trending tags:")]),
                    _vm._v(" "),
                    _vm._l(_vm.relatedTags, function(relatedTag, index) {
                      return _c(
                        "a",
                        {
                          key: "relate-tag" + index,
                          staticClass: "badge badge-success ml-2",
                          attrs: { href: "#" },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.setTag(relatedTag)
                            }
                          }
                        },
                        [_vm._v(_vm._s(relatedTag.name))]
                      )
                    })
                  ],
                  2
                )
              : _vm._e()
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-md-12" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-md-8" }, [
              _c("div", { staticClass: "row no-gutters" }, [
                _c(
                  "div",
                  { staticClass: "col-md-12" },
                  _vm._l(
                    _vm._.filter(_vm.deliverableTemplateDetail.customFields, {
                      field_key: "social_media_plan_details"
                    }),
                    function(field, index) {
                      return _c(
                        "div",
                        { key: index, staticClass: "field-box" },
                        [
                          _c("DeliverableCustomFields", {
                            attrs: {
                              deliverable: _vm.deliverableTemplateDetail,
                              customField: field,
                              namespace: _vm.namespace
                            }
                          })
                        ],
                        1
                      )
                    }
                  ),
                  0
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-md-12" },
                  _vm._l(
                    _vm._.filter(_vm.deliverableTemplateDetail.customFields, {
                      field_key: "questions"
                    }),
                    function(field, index) {
                      return _c(
                        "div",
                        { key: index, staticClass: "field-box" },
                        [
                          _c("DeliverableCustomFields", {
                            attrs: {
                              deliverable: _vm.deliverableTemplateDetail,
                              customField: field,
                              namespace: _vm.namespace,
                              readOnly: true
                            }
                          })
                        ],
                        1
                      )
                    }
                  ),
                  0
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-md-12" },
                  _vm._l(
                    _vm._.filter(_vm.deliverableTemplateDetail.customFields, {
                      field_key: "responses"
                    }),
                    function(field, index) {
                      return _c(
                        "div",
                        { key: index, staticClass: "field-box" },
                        [
                          _c("DeliverableCustomFields", {
                            attrs: {
                              deliverable: _vm.deliverableTemplateDetail,
                              customField: field,
                              namespace: _vm.namespace,
                              readOnly: true
                            }
                          })
                        ],
                        1
                      )
                    }
                  ),
                  0
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-md-12" },
                  _vm._l(
                    _vm._.filter(_vm.deliverableTemplateDetail.customFields, {
                      field_key: "notes_research"
                    }),
                    function(field, index) {
                      return _c(
                        "div",
                        { key: index, staticClass: "field-box" },
                        [
                          _c("DeliverableCustomFields", {
                            attrs: {
                              deliverable: _vm.deliverableTemplateDetail,
                              customField: field,
                              namespace: _vm.namespace,
                              readOnly: true
                            }
                          })
                        ],
                        1
                      )
                    }
                  ),
                  0
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-md-12" },
                  _vm._l(
                    _vm._.filter(_vm.deliverableTemplateDetail.customFields, {
                      field_key: "location_text"
                    }),
                    function(field, index) {
                      return _c(
                        "div",
                        { key: index, staticClass: "field-box" },
                        [
                          _c("DeliverableCustomFields", {
                            attrs: {
                              deliverable: _vm.deliverableTemplateDetail,
                              customField: field,
                              namespace: _vm.namespace
                            }
                          })
                        ],
                        1
                      )
                    }
                  ),
                  0
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-4" }, [
              _c("div", { staticClass: "row no-gutters" }, [
                _c("div", { staticClass: "col-md-12" }, [
                  _c("div", { staticClass: "row no-gutters" }, [
                    _c("div", { staticClass: "col-md-12" }, [
                      _c(
                        "div",
                        { staticClass: "field-box" },
                        [
                          _c(
                            "div",
                            { staticClass: "field-container--priority" },
                            [
                              _c("div", { staticClass: "field-header" }, [
                                _c("div", { staticClass: "field-label" }, [
                                  _vm._v("Roles")
                                ]),
                                _vm._v(" "),
                                false
                                  ? _c(
                                      "button",
                                      {
                                        ref: "refApplyRoleChanges",
                                        staticClass: "btn btn-theme",
                                        staticStyle: {
                                          float: "right",
                                          "margin-top": "7px",
                                          "margin-right": "7px"
                                        },
                                        on: { click: _vm.updateRoles }
                                      },
                                      [
                                        _vm._v("Apply Changes "),
                                        _c(
                                          "div",
                                          {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value: _vm.applyingChanges,
                                                expression: "applyingChanges"
                                              }
                                            ],
                                            staticClass:
                                              "ml-2 spinner-border spinner-border-sm text-primary",
                                            attrs: { role: "status" }
                                          },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "sr-only" },
                                              [_vm._v("Loading...")]
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c("multiselect", {
                            ref: "role",
                            attrs: {
                              "track-by": "id",
                              label: "name",
                              "open-direction": "bottom",
                              options: _vm.allRoles,
                              "show-labels": false,
                              multiple: true,
                              allowEmpty: true,
                              taggable: true,
                              "close-on-select": false,
                              "hide-selected": false,
                              "preserve-search": true,
                              "clear-on-select": false
                            },
                            on: {
                              input: function($event) {
                                return _vm.getRolePermissions()
                              },
                              close: function($event) {
                                return _vm.updateRoles()
                              }
                            },
                            model: {
                              value: _vm.deliverableTemplateSelectedRoles,
                              callback: function($$v) {
                                _vm.deliverableTemplateSelectedRoles = $$v
                              },
                              expression: "deliverableTemplateSelectedRoles"
                            }
                          }),
                          _c("br")
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-md-12" },
                      _vm._l(
                        _vm._.filter(
                          _vm.deliverableTemplateDetail.customFields,
                          { field_key: "priority" }
                        ),
                        function(field, index) {
                          return _c(
                            "div",
                            { key: index, staticClass: "field-box" },
                            [_vm._m(6, true)]
                          )
                        }
                      ),
                      0
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "col-md-6",
                        staticStyle: { "padding-right": "10px" }
                      },
                      _vm._l(
                        _vm._.filter(
                          _vm.deliverableTemplateDetail.customFields,
                          { field_key: "start_date" }
                        ),
                        function(field, index) {
                          return _c(
                            "div",
                            { key: index, staticClass: "field-box" },
                            [
                              _c("DeliverableCustomFields", {
                                attrs: {
                                  deliverable: _vm.deliverableTemplateDetail,
                                  customField: field,
                                  namespace: _vm.namespace,
                                  disabled: true
                                }
                              })
                            ],
                            1
                          )
                        }
                      ),
                      0
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "col-md-6",
                        staticStyle: { "padding-left": "10px" }
                      },
                      _vm._l(
                        _vm._.filter(
                          _vm.deliverableTemplateDetail.customFields,
                          { field_key: "end_date" }
                        ),
                        function(field, index) {
                          return _c(
                            "div",
                            { key: index, staticClass: "field-box" },
                            [
                              _c("DeliverableCustomFields", {
                                attrs: {
                                  deliverable: _vm.deliverableTemplateDetail,
                                  customField: field,
                                  namespace: _vm.namespace,
                                  disabled: true
                                }
                              })
                            ],
                            1
                          )
                        }
                      ),
                      0
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-md-12" },
                      _vm._l(
                        _vm._.filter(
                          _vm.deliverableTemplateDetail.customFields,
                          { field_key: "start_datetime" }
                        ),
                        function(field, index) {
                          return _c(
                            "div",
                            { key: index, staticClass: "field-box" },
                            [
                              _c("DeliverableCustomFields", {
                                attrs: {
                                  deliverable: _vm.deliverableTemplateDetail,
                                  customField: field,
                                  namespace: _vm.namespace
                                }
                              })
                            ],
                            1
                          )
                        }
                      ),
                      0
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-md-12" },
                      _vm._l(
                        _vm._.filter(
                          _vm.deliverableTemplateDetail.customFields,
                          { field_key: "end_datetime" }
                        ),
                        function(field, index) {
                          return _c(
                            "div",
                            { key: index, staticClass: "field-box" },
                            [
                              _c("DeliverableCustomFields", {
                                attrs: {
                                  deliverable: _vm.deliverableTemplateDetail,
                                  customField: field,
                                  namespace: _vm.namespace
                                }
                              })
                            ],
                            1
                          )
                        }
                      ),
                      0
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-md-12" },
                      _vm._l(
                        _vm._.filter(
                          _vm.deliverableTemplateDetail.customFields,
                          { field_key: "publish_datetime" }
                        ),
                        function(field, index) {
                          return _c(
                            "div",
                            { key: index, staticClass: "field-box" },
                            [
                              _c("DeliverableCustomFields", {
                                attrs: {
                                  deliverable: _vm.deliverableTemplateDetail,
                                  customField: field,
                                  namespace: _vm.namespace
                                }
                              })
                            ],
                            1
                          )
                        }
                      ),
                      0
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-md-12" },
                      _vm._l(
                        _vm._.filter(
                          _vm.deliverableTemplateDetail.templateCustomFields,
                          { field_key: "marketing_officer" }
                        ),
                        function(field, index) {
                          return _c(
                            "div",
                            { key: index, staticClass: "field-box" },
                            [
                              _c("DeliverableCustomFields", {
                                attrs: {
                                  deliverable: _vm.deliverableTemplateDetail,
                                  customField: field,
                                  namespace: _vm.namespace
                                }
                              })
                            ],
                            1
                          )
                        }
                      ),
                      0
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-md-12" },
                      [
                        _c(
                          "b-tabs",
                          {
                            staticClass: "field-tabs",
                            attrs: {
                              "content-class": "field-tab-content",
                              fill: ""
                            },
                            model: {
                              value: _vm.currentTab,
                              callback: function($$v) {
                                _vm.currentTab = $$v
                              },
                              expression: "currentTab"
                            }
                          },
                          [
                            _vm.hasContactFields()
                              ? _c(
                                  "b-tab",
                                  {
                                    staticClass: "field-tab-research field-box",
                                    attrs: { active: "", title: "Contact" }
                                  },
                                  [
                                    _c("DeliverableContactPlaceholder", {
                                      attrs: {
                                        deliverableDetail:
                                          _vm.deliverableTemplateDetail,
                                        disabled: true
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.hasChat()
                              ? _c(
                                  "b-tab",
                                  {
                                    staticClass: "field-tab-chat",
                                    attrs: {
                                      lazy: _vm.lazyLoadChat,
                                      title: "Chat"
                                    },
                                    on: { click: _vm.turnOffLazy }
                                  },
                                  [_c("div", { staticClass: "chat-wrapper" })]
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-md-12" },
                      _vm._l(
                        _vm._.filter(
                          _vm.deliverableTemplateDetail.customFields,
                          { field_key: "website" }
                        ),
                        function(field, index) {
                          return _c(
                            "div",
                            { key: index, staticClass: "field-box" },
                            [
                              _c("DeliverableCustomFields", {
                                attrs: {
                                  deliverable: _vm.deliverableTemplateDetail,
                                  customField: field,
                                  namespace: _vm.namespace
                                }
                              })
                            ],
                            1
                          )
                        }
                      ),
                      0
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "col-md-6",
                        staticStyle: { "padding-right": "10px" }
                      },
                      _vm._l(
                        _vm._.filter(
                          _vm.deliverableTemplateDetail.customFields,
                          { field_key: "interview_given" }
                        ),
                        function(field, index) {
                          return _c(
                            "div",
                            { key: index, staticClass: "field-box" },
                            [
                              _c("DeliverableCustomFields", {
                                attrs: {
                                  deliverable: _vm.deliverableTemplateDetail,
                                  customField: field,
                                  namespace: _vm.namespace
                                }
                              })
                            ],
                            1
                          )
                        }
                      ),
                      0
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "col-md-6",
                        staticStyle: { "padding-right": "10px" }
                      },
                      _vm._l(
                        _vm._.filter(
                          _vm.deliverableTemplateDetail.customFields,
                          { field_key: "referred_to_external" }
                        ),
                        function(field, index) {
                          return _c(
                            "div",
                            { key: index, staticClass: "field-box" },
                            [
                              _c("DeliverableCustomFields", {
                                attrs: {
                                  deliverable: _vm.deliverableTemplateDetail,
                                  customField: field,
                                  namespace: _vm.namespace
                                }
                              })
                            ],
                            1
                          )
                        }
                      ),
                      0
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-md-12" },
                      _vm._l(
                        _vm._.filter(
                          _vm.deliverableTemplateDetail.customFields,
                          { field_key: "french_request" }
                        ),
                        function(field, index) {
                          return _c(
                            "div",
                            { key: index, staticClass: "field-box" },
                            [
                              _c("DeliverableCustomFields", {
                                attrs: {
                                  deliverable: _vm.deliverableTemplateDetail,
                                  customField: field,
                                  namespace: _vm.namespace
                                }
                              })
                            ],
                            1
                          )
                        }
                      ),
                      0
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-md-12" },
                      _vm._l(
                        _vm._.filter(
                          _vm.deliverableTemplateDetail.customFields,
                          { field_key: "language" }
                        ),
                        function(field, index) {
                          return _c(
                            "div",
                            { key: index, staticClass: "field-box" },
                            [
                              _c("DeliverableCustomFields", {
                                attrs: {
                                  deliverable: _vm.deliverableTemplateDetail,
                                  customField: field,
                                  namespace: _vm.namespace
                                }
                              })
                            ],
                            1
                          )
                        }
                      ),
                      0
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-12 field-box" }, [
                      _c("div", { staticClass: "field-box__header" }, [
                        _c("div", { staticClass: "dropdown" }, [
                          _c(
                            "button",
                            {
                              directives: [
                                {
                                  name: "b-tooltip",
                                  rawName: "v-b-tooltip.hover",
                                  modifiers: { hover: true }
                                }
                              ],
                              staticClass:
                                "add-resource-button exclude-outside-click d-inline-block",
                              attrs: { title: "Read only" }
                            },
                            [_vm._v("Resources")]
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "field-box__content" })
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-3" })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-md-12" },
          [
            _c(
              "div",
              { staticClass: "add-task-button-mobile" },
              [
                !(
                  !_vm.userAbilities.editMediaCall ||
                  _vm.deliverableTemplateDetail.permissions.viewOnly
                )
                  ? _c(
                      "b-button",
                      {
                        staticClass: "add-task-btn",
                        attrs: { variant: "theme" },
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.createTask.apply(null, arguments)
                          }
                        }
                      },
                      [
                        _vm._v("\n          Add Task\n          "),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.addingTask,
                                expression: "addingTask"
                              }
                            ],
                            staticClass:
                              "ml-2 spinner-border spinner-border-sm text-primary",
                            attrs: { role: "status" }
                          },
                          [
                            _c("span", { staticClass: "sr-only" }, [
                              _vm._v("Loading...")
                            ])
                          ]
                        )
                      ]
                    )
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _vm._m(7),
            _vm._v(" "),
            _c("TaskFieldLabels", {
              ref: "TaskFieldLabelsRef",
              attrs: {
                fullDeliverables: _vm.deliverableTemplateDetail,
                deliverableId: _vm.deliverableTemplateDetail.id,
                deliverable: _vm.deliverableTemplateDetail,
                tasks: _vm.deliverableTemplateDetail.tasks,
                namespace: _vm.namespace
              }
            }),
            _vm._v(" "),
            _c("TaskFields", {
              attrs: {
                fullDeliverables: _vm.deliverableTemplateDetail,
                deliverableId: _vm.deliverableTemplateDetail.id,
                deliverable: _vm.deliverableTemplateDetail,
                tasks: _vm.deliverableTemplateDetail.tasks,
                namespace: _vm.namespace
              }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "responsive-edit-modal-controls",
          class: _vm.showModalOptions ? "open" : ""
        },
        [
          _c(
            "button",
            {
              directives: [
                {
                  name: "b-tooltip",
                  rawName: "v-b-tooltip.hover",
                  modifiers: { hover: true }
                }
              ],
              staticClass: "btn modal-more-controls",
              attrs: { title: "More options" },
              on: {
                click: function($event) {
                  _vm.showModalOptions = !_vm.showModalOptions
                }
              }
            },
            [
              _c("i", {
                staticClass: "fas",
                class: !_vm.showModalOptions
                  ? "fa-arrow-left"
                  : "fa-arrow-right"
              })
            ]
          ),
          _vm._v(" "),
          _vm.userAbilities.deleteMediaCall &&
          !_vm.deliverableTemplateDetail.permissions.viewOnly &&
          _vm.deliverableTemplateDetail.can_delete
            ? _c(
                "button",
                {
                  directives: [
                    {
                      name: "b-tooltip",
                      rawName: "v-b-tooltip.hover",
                      modifiers: { hover: true }
                    }
                  ],
                  staticClass: "btn delete-deliverable-btn",
                  attrs: { title: _vm.getDeleteDeliverableTitle },
                  on: {
                    click: function($event) {
                      return _vm.removeDeliverable(
                        _vm.deliverableTemplateDetail.id
                      )
                    }
                  }
                },
                [_c("i", { staticClass: "fas fa-trash-alt" })]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.deliverableTemplateDetail.can_be_templated
            ? _c("DuplicateDeliverableTemplateBtn", {
                attrs: {
                  deliverableId: _vm.deliverableTemplateDetail.id,
                  namespace: _vm.namespace,
                  deliverableTemplateId: _vm.deliverableTemplateDetail.id
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _c("FeedbackBtn"),
          _vm._v(" "),
          _c(
            "button",
            {
              directives: [
                {
                  name: "b-tooltip",
                  rawName: "v-b-tooltip.hover",
                  modifiers: { hover: true }
                }
              ],
              staticClass: "btn close-deliverable-btn",
              attrs: { title: "Close" },
              on: { click: _vm.onCloseModal }
            },
            [_c("i", { staticClass: "fas fa-times" })]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            type: "warn",
            title: "Confirm Deletion",
            "ok-title": "Yes, Delete"
          },
          on: { ok: _vm.onConfirmRemoveDeliverable },
          model: {
            value: _vm.showRemoveDeliverable,
            callback: function($$v) {
              _vm.showRemoveDeliverable = $$v
            },
            expression: "showRemoveDeliverable"
          }
        },
        [
          _c("p", [
            _vm._v("Are you sure you want to delete "),
            _c("strong", [_vm._v(_vm._s(_vm.deliverableTemplateDetail.title))]),
            _vm._v(" deliverable template?")
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            centered: "",
            "no-close-on-backdrop": "",
            "hide-footer": "",
            id: "createLinkModal",
            title: "New Resource / Link"
          },
          on: { shown: _vm.focusLinkModal }
        },
        [
          _c("CreateLinkModal", {
            ref: "refLinkModal",
            attrs: {
              "link-url": _vm.linkUrl,
              "link-label": _vm.linkLabel,
              "link-notes": _vm.linkNotes,
              "link-type": _vm.linkType,
              "is-file": _vm.editLinkIsFile,
              "resource-parent": "deliverable",
              namespace: _vm.namespace
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            centered: "",
            "no-close-on-backdrop": "",
            "hide-footer": "",
            id: "editLinkModal",
            title: "Update Resource / Link"
          },
          on: { shown: _vm.focusEditLinkModal }
        },
        [
          _c("EditLinkModal", {
            ref: "refEditLinkModal",
            attrs: {
              "link-url": _vm.linkUrl,
              "link-label": _vm.linkLabel,
              "link-notes": _vm.linkNotes,
              "link-type": _vm.linkType,
              "is-file": _vm.editLinkIsFile,
              namespace: _vm.namespace
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            centered: "",
            id: "linkCopyLinkModal",
            title: "Copy Link",
            "ok-only": "",
            "ok-title": "Done"
          }
        },
        [
          _c("LinkCopyLinkModal", {
            attrs: { linkUrl: _vm.linkCopyModalValue, namespace: _vm.namespace }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "icon-wrapper" }, [
      _c("img", {
        staticClass: "exclude-outside-click",
        attrs: { src: "/images/template-editor-icon-light.svg" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "pb-0 titles exclude-outside-click",
        attrs: { title: "Read Only" }
      },
      [
        _c("div", { staticClass: "department-title exclude-outside-click" }, [
          _vm._v("No Department")
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "pb-0 titles exclude-outside-click",
        attrs: { title: "Read Only" }
      },
      [
        _c("div", { staticClass: "department-title exclude-outside-click" }, [
          _vm._v("No Department")
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "pb-0 titles exclude-outside-click" }, [
      _c(
        "div",
        {
          staticClass: "department-title exclude-outside-click",
          attrs: { title: "Read Only" }
        },
        [_vm._v("No Project")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "default-title-wrapper" }, [
      _c("div", { staticClass: "text-uppercase field-label" }, [
        _vm._v("Title for New Deliverables")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "tags__wrapper" }, [
      _c("div", { staticClass: "deliverable-list-tags" }, [
        _c("span", { staticClass: "text-uppercase field-label" }, [
          _vm._v("Tags")
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "info-bubbles cursor-pointer exclude-outside-click",
            attrs: { title: "Read Only" }
          },
          [
            _c(
              "span",
              {
                staticClass:
                  "exclude-outside-click badge badge-gray deliverable-tags"
              },
              [_vm._v("No Tags")]
            )
          ]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: " field-container--priority",
        attrs: { title: "Read Only" }
      },
      [
        _c("div", { staticClass: "field-header" }, [
          _c("div", { staticClass: "field-label" }, [_vm._v("Priority")])
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "default-title exclude-outside-click" }, [
      _c("strong", [_vm._v("Reorder tasks by Dragging")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }